<template>
    <div id="tips_words">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="title flex jb ac">
                        <p>推荐提示词</p>
                        <div class="close">
                            <img src="./img/close.png"
                                 @click="close_tips_com" />
                        </div>
                    </div>
                    <div class="tab">
                        <el-tabs v-model="activeName"  @tab-click="tabClick">
                            <el-tab-pane :label="name" v-for="(name, index) in tabNameList"
                                         :key="index" :name="name">
                                <div class="tab_cons" v-if="name==activeName">
                                    <div class="tab_cons_item" :class="item2.active?'active':''" v-for="(item2,index2) in tab_item_list" :key="index2"  @click="choose(item2, index2)">
                                        <img :src="'https://wenku202404.oss-cn-beijing.aliyuncs.com/fengge'+item2.img"  class="pic" />
                                        <p>{{item2.name}}</p>
                                        <img src="./img/icon_img51.png" v-if="item2.active" class="icon_close" @click.stop="handledelete(item2, index2)" />
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="btn">
                        <span @click="handleAdd">添加提示词</span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data () {
        return {
            activeName: '风格',
            tabNameList:[
                '风格','场景','视角','色系','材质','灯光','大师','建筑','布局','时尚','国风','影游','人像'
            ],
            tab_item_list:[],
            tabList: [],
        }
    },
    computed: {
        hav_choose_tips () {
            return this.$store.state.hav_choose_tips
        }
    },
    created () {
        this.tabList = TabList
        this.tabList[0].item_list.forEach(m => {
            m.active = false
        })
        this.tab_item_list = this.tabList[0].item_list
    },
    methods: {
        tabClick(tab){
            this.tabList.forEach(e => {
                if(e.name == this.activeName){
                    e.item_list.forEach(m => {
                        m.active = false
                    })
                    this.tab_item_list = e.item_list
                }
            })
        },
        close_tips_com () {
            this.$store.commit('setTipsCom', false)
        },
        choose (item, index) {
            item.active = true
            this.tab_item_list.splice(index, 1, item)
        },
        handledelete (item, index) {
            item.active = false
            this.tab_item_list.splice(index, 1, item)
        },
        handleAdd () {
            let _arr = []
            this.tabList.forEach(e => {
                e.item_list.forEach(j => {
                    if (j.active == true) {
                        _arr.push(j)
                    }
                })
            })
            this.$store.commit('setChooseTips', _arr)
            this.close_tips_com()
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#tips_words {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 825px;
            padding: 0;
            background-color: #1e1f22;
            border: 2px solid #5865f2;
            border-radius: 6px;
            max-height: 90vh;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
                position: relative;
                padding: 16px 16px 0 16px;
                p {
                    font-size: 16px;
                    color: #fff;
                }
                .close {
                    border-radius: 6px;
                    box-sizing: border-box;
                    width: 26px;
                    height: 26px;
                    padding: 5px;
                    cursor: pointer;
                    img {
                        width: 100%;
                    }
                    &:hover {
                        background: #343538;
                    }
                }
            }
            .tab {
                padding: 0 16px;
                overflow: hidden;
                display: flex;
                /deep/.el-tabs {
                    display: flex;
                    flex-direction: column;
                    overflow: hidden;
                }
                /deep/.el-tabs__content {
                    flex: 1;
                    overflow: auto;
                }
                /deep/.el-tabs__item {
                    color: #fff;
                }
                /deep/.is-active {
                    color: #5865f2 !important;
                }
                /deep/.el-tabs__nav-wrap::after {
                    background-color: #323335 !important;
                }
                /deep/.el-tabs__active-bar {
                    background-color: #5865f2 !important;
                }
                .tab_cons {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;

                    .tab_cons_item {
                        width: 79px;
                        height: 79px;
                        border: 2px solid #333;
                        border-radius: 8px;
                        position: relative;
                        overflow: hidden;
                        cursor: pointer;
                        .pic {
                            width: 75px;
                            height: 75px;
                        }
                        p {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            right: 0;
                            width: 100%;
                            line-height: 24px;
                            font-size: 12px;
                            color: #fff;
                            text-align: center;
                            background: rgba(0, 0, 0, 0.56);
                        }
                        &.active {
                            border-color: #5865f2;
                            &:before {
                                content: "";
                                position: absolute;
                                top: 0;
                                right: 0;
                                left: 0;
                                bottom: 0;
                                background: rgba(0, 0, 0, 0.3);
                            }
                            p {
                                color: #5865f2;
                            }
                        }
                        .icon_close {
                            position: absolute;
                            top: 4px;
                            right: 4px;
                            border-radius: 16px;
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .btn {
                background-color: #2b2d31;
                text-align: center;
                padding: 12px 0;
                margin-top: 10px;
                span {
                    display: inline-block;
                    cursor: pointer;
                    background-color: #5865f2;
                    color: #fff;
                    border-radius: 10rpx;
                    font-size: 14px;
                    line-height: 36px;
                    padding: 0 60px;
                    border-radius: 4px;
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>